import { Component, OnInit } from '@angular/core';
import { da, tr } from 'date-fns/locale';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IExam } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-assign-examiners',
  templateUrl: './assign-examiners.component.html',
  styleUrls: ['./assign-examiners.component.scss']
})
export class AssignExaminersComponent implements OnInit {

  reassignExistingExaminers: boolean;
  includeWrittenExamsOnly: boolean;
  exam: IExam = examDefault;

  constructor(private popoverRef: PopoverRef<AssignExaminersComponent>,
    private examsevice: ExamService, private snackBar: SnackbarService,) { }

  ngOnInit() {
    if (this.examsevice.selectedExams.length === 1) {
      this.exam = this.examsevice.selectedExams[0];
    }
  }

  close() {
    this.popoverRef.close();
  }

  async runAssingExaminer() {
    try {
      let data = {
        examinationID: this.exam.id,
        reassignExistingExaminers: this.reassignExistingExaminers,
        includeWrittenExamsOnly: this.includeWrittenExamsOnly
      };
      await this.examsevice.assignSchedulesExaminer(data).then(s => {
        this.snackBar.success('Examiners Assigned Successfully');
        this.popoverRef.close();
      });
    } catch (error) {
      console.log(error);
      this.snackBar.error('Error Uploading: ' + error);
    }
  }
}
